/** @type {number} 设计稿基准宽度（px） */
export const DESIGN_WIDTH = 1920

/** @type {string[]} ATS 全屏专题页路由（与 router 保持一致） */
export const ATS_ROUTE_PATHS = [
  '/about-the-savior',
  '/global-rescue',
  '/rescue-list',
  '/rescuelist',
  '/health-monitoring',
  '/first-aid-kit',
  '/company-intro'
]

/**
 * 是否为 ATS 全屏专题页
 * @param {string} pathname
 * @returns {boolean}
 */
export function isAtsRoute (pathname) {
  const path = (pathname || '').replace(/\/$/, '') || '/'
  return ATS_ROUTE_PATHS.indexOf(path) !== -1
}

/**
 * 当前视口宽度（不含滚动条）
 * @returns {number}
 */
export function getViewportWidth () {
  return document.documentElement.clientWidth || window.innerWidth || DESIGN_WIDTH
}

/**
 * 首页等非 ATS 页的根级缩放比（最大 1）
 * @param {number} [viewportWidth]
 * @returns {number}
 */
export function getRootPageScale (viewportWidth) {
  const w = viewportWidth != null ? viewportWidth : getViewportWidth()
  return Math.min(w / DESIGN_WIDTH, 1)
}

/**
 * ATS 专题页缩放比：按视口宽度等比铺满，可大于 1
 * @param {number} [viewportWidth]
 * @returns {number}
 */
export function getAtsScale (viewportWidth) {
  const w = viewportWidth != null ? viewportWidth : getViewportWidth()
  return w / DESIGN_WIDTH
}

/**
 * 清除 html 根节点 zoom（ATS 页由 AtsViewportScale 单独缩放）
 * @returns {void}
 */
export function clearRootPageZoom () {
  document.documentElement.style.zoom = ''
}

/**
 * 为首页等非 ATS 页应用 html 根级 zoom
 * @returns {number}
 */
export function applyRootPageZoom () {
  if (isAtsRoute(window.location.pathname)) {
    clearRootPageZoom()
    document.documentElement.style.setProperty('--page-scale', '1')
    return 1
  }

  const scale = getRootPageScale()
  document.documentElement.style.setProperty('--page-scale', String(scale))

  if (scale < 0.999 && typeof document.documentElement.style.zoom !== 'undefined') {
    document.documentElement.style.zoom = String(scale)
  } else {
    clearRootPageZoom()
  }

  return scale
}



// WEBPACK FOOTER //
// ./src/util/pageScale.js